// ACTIONS
export const FETCH = 'offerzen/interviewRequests/FETCH'
export const FETCH_LOADING = 'offerzen/interviewRequests/FETCH_LOADING'
export const FETCH_SUCCESS = 'offerzen/interviewRequests/FETCH_SUCCESS'

export const FETCH_DETAIL = 'offerzen/interviewRequests/FETCH_DETAIL'
export const FETCH_DETAIL_SUCCESS = 'offerzen/interviewRequests/FETCH_DETAIL_SUCCESS'

export const FETCH_COUNTS = 'offerzen/interviewRequests/FETCH_COUNTS'
export const FETCH_COUNTS_SUCCESS = 'offerzen/interviewRequests/FETCH_COUNTS_SUCCESS'

export const SET_STATUS = 'offerzen/interviewRequests/SET_STATUS'
export const UPDATING = 'offerzen/interviewRequests/UPDATING'
export const UPDATING_CANDIDATE_STATUS = 'offerzen/interviewRequests/UPDATING_CANDIDATE_STATUS'
export const SET_STATUS_SUCCESS = 'offerzen/interviewRequests/SET_STATUS_SUCCESS'
export const SET_STATUS_FAILURE = 'offerzen/interviewRequests/SET_STATUS_FAILURE'

export const SET_CANDIDATE_STATUS = 'offerzen/interviewRequests/SET_CANDIDATE_STATUS'
export const SET_CANDIDATE_STATUS_SUCCESS = 'offerzen/interviewRequests/SET_CANDIDATE_STATUS_SUCCESS'

export const TOGGLE_SETTING_DECLINE_REASON = 'offerzen/interviewRequests/TOGGLE_SETTING_DECLINE_REASON'
export const SET_DECLINE_REASON = 'offerzen/interviewRequests/SET_DECLINE_REASON'
export const TOGGLE_DECLINE_REASONS_MODAL = 'offerzen/interviewRequests/TOGGLE_DECLINE_REASONS_MODAL'

export const RESET_MEMBER = 'offerzen/interviewRequests/RESET_MEMBER'

// ACTION CREATORS
export const fetch = (id, filter) => ({
  type: FETCH,
  payload: {
    id,
    filter,
  },
})

export const fetchLoading = value => ({
  type: FETCH_LOADING,
  payload: value,
})

export const fetchSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    loading: false,
    interview_requests: data.result,
  },
})

export const fetchDetail = id => ({
  type: FETCH_DETAIL,
  payload: id,
})

export const fetchDetailSuccess = data => ({
  type: FETCH_DETAIL_SUCCESS,
  payload: {
    loading: false,
    interview_request: data.result,
  },
})

export const fetchCounts = id => ({
  type: FETCH_COUNTS,
  payload: id,
})

export const fetchCountsSuccess = data => ({
  type: FETCH_COUNTS_SUCCESS,
  payload: data.result,
})

export const setStatus = (id, data) => ({
  type: SET_STATUS,
  payload: {
    id,
    data,
  },
})

export const setCandidateStatus = (id, data) => ({
  type: SET_CANDIDATE_STATUS,
  payload: {
    id,
    data,
  },
})

export const updating = value => ({
  type: UPDATING,
  payload: value,
})

export const updatingCandidateStatus = value => ({
  type: UPDATING_CANDIDATE_STATUS,
  payload: value,
})

export const setStatusSuccess = data => ({
  type: SET_STATUS_SUCCESS,
  payload: {
    updating: false,
    interview_request: data.result,
  },
})

export const setStatusFailure = errorMessage => ({
  type: SET_STATUS_FAILURE,
  payload: {
    updating: false,
    setStatusError: new Error(errorMessage),
  },
})

export const setCandidateStatusSuccess = data => ({
  type: SET_CANDIDATE_STATUS_SUCCESS,
  payload: {
    updatingCandidateStatus: false,
    interview_request: data.result,
  },
})

export const setDeclineReason = (id, data) => {
  return {
    type: SET_DECLINE_REASON,
    payload: {
      id,
      data,
    },
  }
}

export const toggleSettingDeclineReason = settingDeclineReason => ({
  type: TOGGLE_SETTING_DECLINE_REASON,
  payload: settingDeclineReason,
})

export const toggleDeclineReasonsModal = isDeclineReasonsModalActive => ({
  type: TOGGLE_DECLINE_REASONS_MODAL,
  payload: isDeclineReasonsModalActive,
})

export const resetMember = () => ({
  type: RESET_MEMBER,
  payload: {
    loading: true,
    member: {},
  },
})

// REDUCERS
const initialState = {
  loading: true,
  updating: false,
  updatingCandidateStatus: false,
  settingDeclineReason: false,
  isDeclineReasonsModalActive: false,
  requestCounts: {
    all: '—',
    pending: '—',
    accepted: '—',
    declined: '—',
  },
  member: {
    hiring_team: {},
    company_profile: {},
    job: {},
  },
}

const interviewRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case FETCH_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
        collection: action.payload.interview_requests,
      }

    case UPDATING:
      return {
        ...state,
        updating: action.payload,
      }

    case UPDATING_CANDIDATE_STATUS:
      return {
        ...state,
        updatingCandidateStatus: action.payload,
      }

    case SET_STATUS_SUCCESS:
      return {
        ...state,
        updating: action.payload.updating,
        member: action.payload.interview_request,
      }

    case SET_CANDIDATE_STATUS_SUCCESS:
      return {
        ...state,
        updatingCandidateStatus: action.payload.updatingCandidateStatus,
      }

    case FETCH_DETAIL_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
        member: action.payload.interview_request,
      }

    case FETCH_COUNTS_SUCCESS:
      return {
        ...state,
        requestCounts: action.payload,
      }

    case SET_STATUS_FAILURE:
      return {
        ...state,
        updating: action.payload.updating,
        setStatusError: action.payload.setStatusError,
      }

    case TOGGLE_SETTING_DECLINE_REASON:
      return {
        ...state,
        settingDeclineReason: action.payload,
      }

    case TOGGLE_DECLINE_REASONS_MODAL:
      return {
        ...state,
        isDeclineReasonsModalActive: action.payload,
      }

    case RESET_MEMBER:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export default interviewRequestsReducer

export const getInterviewRequestsView = state => state.views.interviewRequests.interviewRequests || initialState
